import { h } from "@stencil/core";
const cssStyle = {
  "background-color": "red",
  "color": "white",
  "display": "inline-block",
  "padding": "3px",
};
export const renderInlineError = errorText => h("div", { style: cssStyle }, errorText);
